import { ChartPoint } from "../../types";
import { EvenAxis } from "./types";

const TICK_COUNT = 4;
const STEP_MULTIPLIERS = [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10];

const clean = (value: number) => Number(value.toPrecision(12));

export const evenAxisOf = (peak: number): EvenAxis => {
  const target = Math.max(peak, 1) / TICK_COUNT;
  const magnitude = 10 ** Math.floor(Math.log10(target));
  const multiplier =
    STEP_MULTIPLIERS.find((candidate) => candidate * magnitude >= target) ?? 10;
  const step = clean(multiplier * magnitude);
  const ticks = Array.from({ length: TICK_COUNT + 1 }, (_, index) =>
    clean(step * index),
  );
  return { max: ticks[TICK_COUNT], ticks };
};

// An overdraft needs a negative range, which the even 0-based axis cannot draw.
export const progressAxisOf = (points: ChartPoint[]): EvenAxis | null => {
  const values = points.flatMap(({ balance, netContributed }) => [
    balance,
    netContributed,
  ]);
  if (values.some((value) => value < 0)) {
    return null;
  }
  return evenAxisOf(Math.max(0, ...values));
};
